export function initTelegram() {
  if (window.Telegram?.WebApp) {
    window.Telegram.WebApp.ready();
    window.Telegram.WebApp.expand();
  };
}

export function openTelegramLink(url) {
    if (isTelegramMiniApp()) {
      try {
        window.Telegram?.WebApp.openTelegramLink(url);
      } catch (err) {
        console.error('Telegram openTelegramLink failed, falling back:', err);
        window.open(url, '_blank');
      }
    } else {
      window.open(url, '_blank');
    }
}

export function isTelegramMiniApp() {
  return !!window.Telegram?.WebApp.initData;
}

export function isTelegramAdmin() {
  const ADMIN_TELEGRAM_IDS = [-1227676673, -1990112017, 670807261];
  const tgUser = window.Telegram?.WebApp?.initDataUnsafe?.user;
  return tgUser?.id && ADMIN_TELEGRAM_IDS.includes(sh(String(tgUser.id)));
}

function sh(str) {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = (hash << 5) - hash + str.charCodeAt(i);
    hash |= 0;
  }
  return hash;
}